import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { ROUTES, PAGINAS, FUNCIONALIDADES } from '../../../routes';
import { getTipoComorbidade, cadastrarTipoComorbidade, alterarTipoComorbidade, excluirTipoComorbidade } from './tipos_comorbidades_service';
import { CadastroBasicoNomeSituacaoForm } from '../../../components/CadastroBasicoNomeSituacaoForm';
export var TiposComorbidadesAlterar = function () {
    var services = {
        getItem: getTipoComorbidade,
        cadastrarItem: cadastrarTipoComorbidade,
        alterarItem: alterarTipoComorbidade,
        excluirItem: excluirTipoComorbidade,
    };
    return _jsx(CadastroBasicoNomeSituacaoForm, { pagina: PAGINAS.TIPOS_COMORBIDADES, paginaPermissao: FUNCIONALIDADES.TIPOS_COMORBIDADES, rota: ROUTES.TIPOS_COMORBIDADES, services: services });
};
export default TiposComorbidadesAlterar;
